import logger from 'utils/logger.util';

const L = logger('isNotEnumVal');

const isNotEnumVal = (enumeration, val) => {
  try {
    return !Object.values(enumeration).includes(val);
  } catch (e) {
    L.warn('()', e);
    return true;
  }
};

// noinspection JSUnusedGlobalSymbols
export default isNotEnumVal;
